import axios from '@/plugins/axios';

export const EDIT_PASSWORD = '/user/edit-password';

export async function editPassword(form) {
  try {
    const { data } = await axios.put(EDIT_PASSWORD, form);
    return data;
  } catch (error) {
    return { error };
  }
}
